import { render, staticRenderFns } from "./Comercial.vue?vue&type=template&id=2ec8a5f4&scoped=true&"
import script from "./Comercial.vue?vue&type=script&lang=js&"
export * from "./Comercial.vue?vue&type=script&lang=js&"
import style0 from "./Comercial.vue?vue&type=style&index=0&id=2ec8a5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8a5f4",
  null
  
)

component.options.__file = "Comercial.vue"
export default component.exports